<p-chip
  [label]="getStatus()"
  [icon]="iconVisible ? getIconSeverity() : ''"
  [styleClass]="small ? 'text-xs ' + getServerity() : getServerity()"
/>
